import { AbstractModel, Column, DataType, Index, Mime, Model } from "@clairejs/core";

@Model()
@Index([["name", "text"]])
export class Service extends AbstractModel {
    @Column({
        description: "Service name",
        isRequired: true,
    })
    name!: string;

    @Column({
        isRequired: true,
        description: "Service description",
    })
    description!: string;

    @Column({
        description: "Whether an additional location input is require",
    })
    additionalLocationRequired?: boolean;

    @Column({
        description: "Hide search description by default on client",
    })
    defaultHideSearchDescription?: boolean;

    nameLocale?: Record<string, string>;

    descriptionLocale?: Record<string, string>;

    @Column({
        description: "The countries that this service is available",
        vectorProps: { elementDataType: DataType.STRING },
    })
    countries?: string[];

    @Column({
        mimeProps: { type: Mime.IMAGE },
    })
    iconUrl?: string;

    @Column({
        description: "Number of registered profiles on this service per region",
    })
    profileCount?: number;

    @Column({
        description: "Number of searches perform on this service per region",
    })
    searchCount?: Record<string, number>;

    @Column({
        description: "Whether auto pricing is enabled for this service",
    })
    autoPricingEnabled?: boolean;

    @Column({
        description: "The base price for this service (in coins)",
    })
    basePrice?: number;

    @Column({
        description: "The price per km of transport (in coins)",
    })
    pricePerUnitOfDistance?: number;

    @Column({
        description: "The min price allow for bids (in coins)",
    })
    bidPriceMin?: number;

    @Column({
        description: "The max price allow for bids (in coins)",
    })
    bidPriceMax?: number;
}
